import { Box, Paper, Skeleton, SxProps } from "@mui/material";
import { StyleguideSavioColors } from "../../configuration/themeSettings";
import { useTranslation } from "../../../explorer/hooks/useTranslation";
import { TablePrice } from "./BasketPage.styles";
import { useUserInfo } from "../../../explorer/hooks/useUserInfo";
import { formatCurrency } from "../../../explorer/helpers/CommonHelper";
import useLanguages from "../../../explorer/hooks/useLanguages";

type TBasketTotalPrice = {
    currency?: string;
    showDiscount?: boolean;
    fullTotal: number;
    netTotal: number;
    discount: number;
    hidePrice: boolean;
    loadingPrices?: boolean;
    collapsed?:boolean;
    className?:SxProps;
};

const BasketTotalPrice = (props: TBasketTotalPrice) => {
    const { fullTotal, netTotal, discount } = props;
    const { t } = useTranslation();
    const [userInfo] = useUserInfo();
    const lang = useLanguages().currentLanguage;

    return userInfo.userPermissions?.canViewPrices ? (
        <Paper elevation={0} sx={props.className}>
            <Box
                sx={{
                    textAlign: "end",
                    padding: 0,
                    backgroundColor: "#fff",
                    justifyContent: "flex-end",
                    display: "flex",
                    borderTop: "1px solid " + StyleguideSavioColors.mainBlue,
                    boxShadow:
                        "rgba(0, 0, 0, 0.2) 0px -4px 12px 0px, rgba(0, 0, 0, 0.14) 0px -1px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 2px -20px",
                }}
            >
                <TablePrice>
                    <tbody>
                        <tr className="totalGrossPrice">
                            <td>{t("common.basket.totalGrossPrice")}</td>
                            {!props.loadingPrices ? (
                                <td>
                                    {props.hidePrice ||
                                    fullTotal === 0 ||
                                    isNaN(fullTotal)
                                        ? "-"
                                        : formatCurrency(
                                              fullTotal,
                                              props.currency,
                                              lang
                                          )}
                                </td>
                            ) : (
                                <td>
                                    <Skeleton width={100}></Skeleton>
                                </td>
                            )}
                        </tr>

                        {props.showDiscount && discount > 0 &&
                            (props.collapsed === undefined ||
                                props.collapsed) && (
                                <tr className="totalDiscount">
                                    <td>{t("basket.totalDiscount")}</td>
                                    <td>
                                        {!props.loadingPrices ? (
                                            props.hidePrice ||
                                            discount === 0 ||
                                            isNaN(discount) ? (
                                                "-"
                                            ) : (
                                                formatCurrency(
                                                    discount,
                                                    props.currency,
                                                    lang
                                                )
                                            )
                                        ) : (
                                            <Skeleton width={100}></Skeleton>
                                        )}
                                    </td>
                                </tr>
                            )}
                        {(props.collapsed === undefined || props.collapsed) && (
                            <tr className="totalNetPrice">
                                <td>{t("common.basket.totalNetPrice")} </td>
                                {!props.loadingPrices ? (
                                    <td>
                                        {props.hidePrice ||
                                        netTotal === 0 ||
                                        isNaN(netTotal)
                                            ? "-"
                                            : formatCurrency(
                                                  netTotal,
                                                  props.currency,
                                                  lang
                                              )}
                                    </td>
                                ) : (
                                    <td>
                                        <Skeleton width={100}></Skeleton>
                                    </td>
                                )}
                            </tr>
                        )}
                    </tbody>
                </TablePrice>
            </Box>
        </Paper>
    ) : (
        <></>
    );
};

export default BasketTotalPrice;
